import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Evidence, EvidenceApproval, EvidenceApprovalResult, TableDataEvidence } from './audit.model';
import { API_URL } from '../app.constants';
import { RequestResult } from '../shared/shared.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EvidenceService {
  constructor(private http: HttpClient) { }

  getEvidence(id: number | string): Observable<Evidence> {
    return this.http.get<Evidence>(`${API_URL}/Evidences/${id}`);
  }
  submitEvidence(e: FormData): Observable<number> {
    return this.http.post<number>(`${API_URL}/Evidences`, e);
  }
  updateEvidence(id: number, e: FormData): Observable<RequestResult> {
    return this.http.patch<RequestResult>(`${API_URL}/Evidences/${id}`, e);
  }
  saveApprovals(capaId: number, data: Array<EvidenceApproval>): Observable<RequestResult> {
    return this.http.post<RequestResult>(`${API_URL}/Evidences/byCapa/${capaId}/updateApprovals`, { approvals: data });
  }
  submitApprovals(capaId: number, data: Array<EvidenceApproval>): Observable<EvidenceApprovalResult> {
    return this.http.post<RequestResult>(`${API_URL}/Evidences/byCapa/${capaId}/submitApprovals`, { approvals: data });
  }

  getEvidenceList(capaId: number = 0, page: number = 0, pageSize: number = 10): Observable<TableDataEvidence<Evidence>> {
    let capaIdUrl = '';
    if (capaId > 0) {
      capaIdUrl = `/byCapa/${capaId}`;
    }

    if (pageSize > 0) {
      return this.http.get<TableDataEvidence<Evidence>>(`${API_URL}/Evidences${capaIdUrl}`, {
        params: {
          Page: (++page).toString(),
          PageSize: pageSize.toString(),
        },
      }).pipe(
        map((res: TableDataEvidence<Evidence>) => {
          res.page--;
  
          return res;
        })
      );
    } else {
      return this.http.get<TableDataEvidence<Evidence>>(`${API_URL}/Evidences${capaIdUrl}`).pipe(
        map((res: TableDataEvidence<Evidence>) => {
          res.page--;

          return res;
        })
      );
    }
  }

  getEvidenceListHistory(capaId: number = 0, page: number = 0, pageSize: number = 10): Observable<TableDataEvidence<Evidence>> {
    let capaIdUrl = '';
    if (capaId > 0) {
      capaIdUrl = `/byCapa/history/${capaId}`;
    }

    if (pageSize > 0) {
      return this.http.get<TableDataEvidence<Evidence>>(`${API_URL}/Evidences${capaIdUrl}`, {
        params: {
          Page: (++page).toString(),
          PageSize: pageSize.toString(),
        },
      }).pipe(
        map((res: TableDataEvidence<Evidence>) => {
          res.page--;
  
          return res;
        })
      );
    } else {
      return this.http.get<TableDataEvidence<Evidence>>(`${API_URL}/Evidences${capaIdUrl}`).pipe(
        map((res: TableDataEvidence<Evidence>) => {
          res.page--;

          return res;
        })
      );
    }
  }

  deleteEvidence(id: number): Observable<RequestResult> {
    return this.http.delete<RequestResult>(`${API_URL}/Evidences/${id}`);
  }

}
